import "./Login.scss";
import { Button } from "../../../components";
import loginImg from "../../../assets/images/bfm.png";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { setToken } from "../../../store/actions";
import { Alert } from "@mui/material";

function Login() {
  const [loginData, setLoginData] = useState({});

  const error = useSelector((state) => state.LoginReducer.errorMessage);
  const success = useSelector((state) => state.LoginReducer.successMessage);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const data = useSelector((state) => state.LoginReducer.data);
  const errorMessage = useSelector((state) => state.LoginReducer.errorMessage);

  const login = () => {
    setLoginData(loginData);
    dispatch(setToken(loginData, navigate));
  };

  useEffect(() => {
    localStorage.getItem("token") && navigate("/buy-for-me");
  }, [navigate, setToken]);

  return (
    <>
      {errorMessage && (
        <div className="login-error-wrapper">
          <Alert severity="error">{errorMessage}!</Alert>
        </div>
      )}
      <div className="login-wrapper">
        <div className="login-image w-50">
          <img
            src={loginImg}
            alt="login-images"
            title="5241364.svg"
            className="image"
          />
        </div>
        <div className="form-wrapper w-50">
          <div className="form-header">
            <h1>Buy For Me</h1>
          </div>
          <div className="form-content m-t20">
            <form className="form">
              <div className="inputs-wrapper">
                <div className="input-wrapper">
                  <label htmlFor="email" className="email-label">
                    Email Address
                  </label>
                  <input
                    type="text"
                    id="email"
                    className="email-input input"
                    onChange={(e) => (loginData.email = e.target.value)}
                  />
                </div>
                <div className="input-wrapper m-t20">
                  <label htmlFor="password" className="password-label">
                    Password
                  </label>
                  <input
                    type="password"
                    id="password"
                    className="password-input input"
                    onChange={(e) => (loginData.password = e.target.value)}
                  />
                </div>
              </div>
              <div className="button-wrapper w-100 m-t20">
                <Button
                  onClick={login}
                  name={"Sign In"}
                  type={"btn-success"}
                  className={"sign-in-btn"}
                />
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
}

export default Login;
